import type { AccountLink } from "@/hooks/queries/useMe";
import { cn } from "@/libs/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";
import MobileNavLinks from "./MobileNavLinks";

export default function AccountLinksList({
  links,
  onClose,
  variant,
  isHomeowner,
  classNames,
}: AccountLinksListProps) {
  return (
    <div
      className={cn(
        "flex flex-col",
        isHomeowner &&
          "[&>a:last-child]:border-t [&>a:last-child]:border-solid [&>a:last-child]:border-default-200 [&>a:last-child]:pt-2 sm:[&>a:last-child]:my-2 gap-2"
      )}
    >
      <MobileNavLinks
        links={links.map((link) => ({
          key: link.id,
          href: link.url,
          label: link.label,
        }))}
        onClose={onClose}
        variant={variant}
        classNames={{ base: classNames?.link }}
      />
    </div>
  );
}

interface AccountLinksListProps {
  links: AccountLink[];
  onClose: () => void;
  variant?: "default" | "nested";
  isHomeowner?: boolean;
  classNames?: SlotsToClasses<"link">;
}
